export {
  default as barResturant,
  ReactComponent as BarResturant,
} from '@assets/icons/use-cases/bar-resturant.svg'    
